import { render } from "./HeroHeader.vue?vue&type=template&id=3d42b87a&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=3d42b87a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d42b87a"]])

export default __exports__